import { API_ADMIN_URL } from "../../../config/constants";
import { postRequest } from "../../API";


/*********************************************************
* Function Name : getLottoGraphData
* Description   : Get list of all service category
* By            : Md Rashid Ali
* Date          : 24-12-2024 
*********************************************************/
export const getLottoGraphData = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}campaign/order/statistics-reports`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Functio

/*********************************************************
* Function Name : getVoucherGraphData
* Description   : Get voucher graph data
* By            : Afsar Ali
* Date          : 08-03-2025 
*********************************************************/
export const getVoucherGraphData = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}promocode/order/statistics-reports`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Functio
/*********************************************************
* Function Name : getProductGraphData
* Description   : Get product graph data
* By            : Afsar Ali
* Date          : 08-03-2025 
*********************************************************/
export const getProductGraphData = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}products/order/statistics-reports`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Functio
/*********************************************************
* Function Name : getLottoWinnersGraphData
* Description   : Get product graph data
* By            : Afsar Ali
* Date          : 08-03-2025 
*********************************************************/
export const getLottoWinnersGraphData = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}lotto-winners/statistics-reports`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Functio
